module.exports = __webpack_public_path__ + "img/Press_Release_RemitPro_x_MoneyGram.331c1e96.jpeg";